import { useMemo } from 'react'

import { FormGroup, Label, Select } from '~/components/unform'
import { useGetFetchQuery } from '~/hooks/useGetFetchQuery'
import { usePublisherConfig } from '~/modules/retailMedia/hooks/usePublisherConfig'

import { PUBLISHER_ID_QUERY_KEY } from '../constants'

const BrandsFieldset = () => {
  const publisherId = useGetFetchQuery<PublisherId>(PUBLISHER_ID_QUERY_KEY)

  // Handle actions

  const { data: publisherConfig } = usePublisherConfig({ publisherId })
  const brands = useMemo(() => publisherConfig?.brands, [publisherConfig])
  const brandOptions = useMemo(
    () =>
      brands?.map(brand => ({
        label: brand.name,
        value: brand.code
      })),
    [brands]
  )

  return (
    brandOptions?.length > 1 && (
      <FormGroup className="d-flex justify-content-between mt-2">
        <Label className="w-75" isRequired>
          Brand for URL
        </Label>
        <Select
          required
          name="brand"
          options={brandOptions}
          placeholder="Select brand"
        />
      </FormGroup>
    )
  )
}

export default BrandsFieldset
